import UserAddAcademics from '../../UserAddAcademics';

const OnboardingStepAcademics = ({ formData, handleChange, errors }) => {
    return (
        <>
            <UserAddAcademics
                formData={formData}
                handleChange={handleChange}
                errors={errors}
                isEditPage={false}
                hideEdit={true}
            />
        </>
    );
};

export default OnboardingStepAcademics;